/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import Auth from "../shared/Auth";
import Globals from "../shared/Globals";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Icon from "./Icon";
import { SidebarGlobal } from "./_SidebarGlobal";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import SignatureCanvas from "react-signature-canvas";
import React from "react";
import { qreq } from "../shared/qrequest";
import LoadingAlert from "./LoadingAlert";
import Patient from "./Patient";
import DocumentList from "./DocumentList";

class IVRSign extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                patient: {}
            }
        };
        this.sigCanvasRef = React.createRef();
        this.iframeRef = React.createRef();
        this.sign = this.sign.bind(this);
    }
    componentDidMount() {
        this.setState({ loaded: false });
        Auth.getLogin(u => {
            if (u && (Auth.hasRole('practitioner') || Auth.hasRole('admin'))) {
                SidebarGlobal.setSubNav(<><div className="btn-group">
                    <button type="button" className="btn btn-success" onClick={() => this.setState({ showSignModal: true })}><Icon icon="faSignature" /> <L>Sign</L></button>
                </div></>);

                qreq.get('/api/order/get/' + this.props.params.orderID, j => {
                    if (j.item)
                        this.setState({ item: j.item });
                    else if (j.errorCode === 9) {
                        qreq.get('/api/lead/get/' + this.props.params.orderID, j => {
                            if (j.item)
                                this.setState({ item: j.item });
                            else
                                this.alert(j.errorMessage);
                        }, this.unkownErrorCallback);
                    }
                    else
                        this.alert(j.errorMessage);
                }, this.unkownErrorCallback);
            }
        });
        this.iframeRef.current.onload = () => {
            this.setState({ loaded: true });
        };
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    sign(e) {
        if (e) e.preventDefault();
        if (this.sigCanvasRef.current.isEmpty()) {
            this.alert('Please sign before submitting.');
            return;
        }
        const signature = this.sigCanvasRef.current.toDataURL('image/png');
        this.setState({ submitting: true });
        qreq.post('/api/document/sign/ivr', { orderID: this.props.params.orderID, dataURL: signature }, j => {
            if (j.errorCode === 0) {
                this.success('Document signed successfully.');
                this.sigCanvasRef.current.clear();
                this.setState({ showSignModal: false, signed: true, loaded: false });
            }
            else {
                this.alert(j.errorMessage);
            }
            this.setState({ submitting: false });
        }, () => {
            this.setState({ submitting: false });
            this.unkownErrorCallback();
        });
    }

    render() {
        return <div className="container-fluid">
            <h1><L>IVR Document</L></h1>
            <Modal show={this.state.showSignModal} onHide={() => this.setState({ showSignModal: false })}>
                <Modal.Header closeButton><L>Sign</L></Modal.Header>
                <form onSubmit={this.sign}>
                    <Modal.Body>
                        <div className="d-grid align-items-center justify-content-center">
                            <SignatureCanvas ref={this.sigCanvasRef} canvasProps={{ width: 400, height: 200, className: 'border' }} />
                            <button type="button" className="btn btn-secondary" onClick={() => this.sigCanvasRef.current.clear()}>Clear Signature</button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success" disable={this.state.submitting}><L>Sign</L></button>
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showSignModal: false })} disabled={this.state.submitting}>Cancel</button>
                    </Modal.Footer>
                </form>
            </Modal>
            <Patient item={this.state.item.patient} readOnly />
            {!this.state.loaded ? <LoadingAlert /> : null}
            <iframe ref={this.iframeRef} src={Globals.serverUrl + '/api/document/render/ivr/' + this.props.params.orderID + '/v2' + (this.state.signed ? '?signed=true' : '')} width="100%" height="1000px" frameBorder="0" title="report"></iframe>
            <DocumentList parentItem={this.state.item} list={this.state.item.documents} />
        </div>;
    }
}

export default withParamsAndNavigate(IVRSign);